import moment from 'moment';
import 'moment/locale/es';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useReducer } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import BatchWidget from '../../../components/AccionaWidgets/BatchWidget';
import { ConcreteTotalWidget } from '../../../components/AccionaWidgets/ConcreteTotalWidget';
import ConcreteTable from '../../../components/AccionaWidgets/ConcreteTotalWidget/ConcreteTable';
import TotalTable from '../../../components/AccionaWidgets/ConcreteTotalWidget/TotalTable';
import { ConcreteWidget } from '../../../components/AccionaWidgets/ConcreteWidget';
import MashWidget from '../../../components/AccionaWidgets/MashWidget';
import {
  getDashboard,
  updateProjectData,
} from '../../../services/api/dashboards';
import AccionaButton from '../../../components/AccionaButton';
import EmissionWidget from './components/EmissionsWidget';

moment.locale(navigator.language.substring(0, 2));

const batch = {
  EHE: {
    solid: 0,
    compression: 0,
    bending: 0,
  },
  CE: {
    type_1: 0,
    type_2: 0,
    type_3: 0,
    type_4: 0,
    type_5: 0,
    type_6: 0,
    type_7: 0,
    type_8: 0,
    type_9: 0,
    type_10: 0,
    type_11: 0,
    type_12: 0,
  },
};

const Dashboard = () => {
  const intl = useIntl();
  const { id } = useParams();
  const timer = useRef();
  const [hookFlag, setHookFlag] = useState(0);
  const [normative, setNormative] = useState(null);
  const [batchList, setBatchList] = useState(null);
  const [mashList, setMashList] = useState(null);
  const [concreteTotal, setConcreteTotal] = useState({
    projected: 0,
    resistant: 0,
    poured: 0,
  });
  const formReducer = (state, action) => {
    switch (action.type) {
      case 'projected':
        return {
          ...state,
          projected: action.value,
        };
      case 'concrete':
        return {
          ...state,
          concrete: action.value,
        };
      case 'batch':
        return {
          ...state,
          batch: action.value,
        };
      case 'updateAll':
        return { ...action.value };

      default:
        return { ...state };
    }
  };

  const [form, dispatchForm] = useReducer(formReducer, {});

  useEffect(() => {
    getDashboard(id)
      .then(({ data: { dashboard, data } }) => {
        setConcreteTotal({
          projected: dashboard.projected || 0,
          resistant: data.total.resistant,
          poured: data.total.poured,
        });
        const concreteList = data.concrete.map((x) => {
          return {
            ...x,
            projected:
              dashboard.concrete.find((d) => d.recipe === x.recipe)
                ?.projected || 0,
          };
        });
        dispatchForm({
          type: 'updateAll',
          value: { ...dashboard, concrete: concreteList, project: id },
        });
        setBatchList({
          total: dashboard.batch,
          work: data.batch,
        });
        setMashList({
          mash_total: data.mash_total,
          mash_control: data.mash_control,
        });
        setNormative(data.normative);
      })
      .catch((error) => {
        const parts = window.location.href.toLowerCase().split('dashboard');

        const domain = parts[0];
        window.location.replace(domain);
      });
  }, [id]);

  const updateConcreteArray = (concreteType, value) => {
    const index = form.concrete.findIndex((x) => x.recipe === concreteType);
    if (index > -1) form.concrete[index].projected = parseInt(value, 10);
    else
      form.concrete.push({
        recipe: concreteType,
        projected: parseInt(value, 10),
      });
    dispatchForm({ type: 'concrete', value: form.concrete });
    saveData({ concrete: form.concrete });
  };

  const onSave = async (value) => {
    await updateProjectData(id, value);
    setHookFlag(hookFlag + 1);
  };

  const saveData = async (value) => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      onSave(value);
    }, 1000);
  };

  const onBack = () => window.history.back();
  if (normative)
    return (
      <div className="wrapper container">
        <div className="row">
          <div className="col-xs-12">
            <div className="form-row align-left-sd no-table">
              <AccionaButton
                msg={intl.formatMessage({ id: 'back' })}
                onClick={onBack}
                style={{ float: 'right', marginRight: '-15px' }}
                classIcon="icon fas fa-chevron-left"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <ConcreteTotalWidget
              title={intl.formatMessage({ id: 'concrete.work' })}
              values={concreteTotal}
              table={
                <TotalTable
                  formValue={form.projected}
                  values={concreteTotal}
                  updateForm={(value) => {
                    dispatchForm({ type: 'projected', value: value });
                    setConcreteTotal((prev) => ({
                      ...prev,
                      projected: parseInt(value, 10),
                    }));
                    saveData({ projected: value });
                  }}
                />
              }
            >
              {form.concrete.map((concrete, index) => {
                return (
                  <Fragment key={`fragment-${index}`}>
                    <div
                      key={`div-${index}`}
                      className="card-header"
                      style={{
                        fontSize: '16px',
                        width: '100%',
                      }}
                    >
                      {concrete.recipe}
                    </div>
                    <ConcreteWidget
                      key={`ConcreteWidget-${index}`}
                      values={concrete}
                      table={
                        <ConcreteTable
                          formValue={form.concrete.find(
                            (x) => x.recipe === concrete.recipe,
                          )}
                          values={concrete}
                          updateForm={updateConcreteArray}
                        />
                      }
                    />
                  </Fragment>
                );
              })}
            </ConcreteTotalWidget>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <BatchWidget
              values={batchList}
              formValue={form.batch}
              updateForm={(value) => {
                dispatchForm({ type: 'batch', value });
                setBatchList((prev) => ({ ...prev, total: value }));
                saveData({ batch: value });
              }}
              title={intl.formatMessage({ id: 'batch.work' })}
              elements={Object.keys(batch[normative])}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <MashWidget
              values={mashList}
              title={intl.formatMessage({ id: 'mash.work' })}
              elements={Object.keys(batch[normative])}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <EmissionWidget />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <div className="form-row align-left-sd no-table">
              <AccionaButton
                msg={intl.formatMessage({ id: 'back' })}
                onClick={onBack}
                style={{ float: 'right', marginRight: '-15px' }}
                classIcon="icon fas fa-chevron-left"
              />
            </div>
          </div>
        </div>
      </div>
    );
  else return null;
};

Dashboard.propTypes = {};

export default Dashboard;
